// extracted by mini-css-extract-plugin
module.exports = {"tablet-landscape-up":"(min-width: calc(1024 * 1px))","desktop-up":"(min-width: calc(1280 * 1px))","block":"SettingsLab_block__2F5vR","item":"SettingsLab_item__3pM2A"};